// extracted by mini-css-extract-plugin
export var hidden = "_s2-0";